import React from 'react';

function Container({ classe, size, padding, children }) {


    const containerSize = size === "small" ? "max-w-6xl" : "max-w-7xl"
    const containerPadding = padding ? padding : "px-4 md:px-6"

    return (
        <div className={`${containerSize} ${containerPadding} ${ classe } h-full mx-auto`}>
            { children }
        </div>
    );
}

export default Container;